export const PAYMENT_SOURCE_TYPE = {
  INVOICE: 'Invoice',
  OFFER: 'Offer',
  TICKET: 'Ticket'
};

export const PAYMENT_METHOD = {
  CASH: 'Cash',
  BANCONTACT: 'Bancontact',
  VERIMENT: 'Veriment',
  NOT_SPECIFIED: 'Not Specified'
};

export const PAYMENT_STATUS = {
  PENDING: 'Pending',
  COMPLETED: 'Completed',
  PARTIAL: 'Partial',
  FAILED: 'Failed',
  REFUNDED: 'Refunded'
};

export const PAYMENT_STATUS_COLORS = {
  [PAYMENT_STATUS.PENDING]: 'warning',
  [PAYMENT_STATUS.COMPLETED]: 'success',
  [PAYMENT_STATUS.PARTIAL]: 'info',
  [PAYMENT_STATUS.FAILED]: 'error',
  [PAYMENT_STATUS.REFUNDED]: 'default'
};

export const DATE_FILTER_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last7days', label: 'Last 7 Days' },
  { value: 'last30days', label: 'Last 30 Days' },
  { value: 'last90days', label: 'Last 90 Days' },
  { value: 'lastyear', label: 'Last Year' },
  { value: 'custom', label: 'Custom Range' }
];

export const SOURCE_TYPE_OPTIONS = [
  { value: '', label: 'All Sources' },
  { value: PAYMENT_SOURCE_TYPE.INVOICE, label: 'Invoice' },
  { value: PAYMENT_SOURCE_TYPE.OFFER, label: 'Offer' },
  { value: PAYMENT_SOURCE_TYPE.TICKET, label: 'Ticket' }
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: '', label: 'All Methods' },
  { value: PAYMENT_METHOD.CASH, label: 'Cash' },
  { value: PAYMENT_METHOD.BANCONTACT, label: 'Bancontact' },
  { value: PAYMENT_METHOD.VERIMENT, label: 'Veriment' },
  { value: PAYMENT_METHOD.NOT_SPECIFIED, label: 'Not Specified' }
];